// types
import { SupportRequestFormType } from '../../types/SupportRequestFormType';

// Shared
import { AxiosAPI } from '../../../../shared/utils/apiRequest';

export const postSupportRequestFormApi = {
  postSupportRequestForm: async (supportRequestForm: SupportRequestFormType): Promise<void> => {
    try {
      const response = await AxiosAPI.post('/post-support-request-form', supportRequestForm);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

